import FocusTrap from '@mui/material/Unstable_TrapFocus'
import React, { cloneElement, createRef } from 'react'
import { createRoot } from 'react-dom/client'

const createModalRoot = () => {
  const rootEl =
    typeof document !== 'undefined' && document.getElementById('ModalWrapper')
  return rootEl ? createRoot(rootEl) : undefined
}

const appendModalWrapperToTheDocument = () => {
  let modalWrapper = document.createElement('div')
  modalWrapper.id = 'ModalWrapper'
  modalWrapper.className = 'ModalWrapper'
  modalWrapper.dataset.sel = 'mdl'
  document.body.appendChild(modalWrapper)
}

//Assures single instance of a root when dealing with multiple modals.
let root = createModalRoot()

export default class Modal {
  constructor() {
    if (!document.getElementById('ModalWrapper')) {
      appendModalWrapperToTheDocument()
    }
    if (!root) {
      root = createModalRoot()
    }
  }

  ref = createRef()

  closeWithEscKey = event => {
    if (event.keyCode === 27) {
      this.closeModal(this)
    }
  }

  handleClickOutside = event => {
    if (this.ref.current && !this.ref.current.contains(event.target)) {
      this.closeModal(this)
    }
  }

  closeModal = modal => {
    document.removeEventListener('keyup', modal.closeWithEscKey)
    document.removeEventListener('mousedown', modal.handleClickOutside, true)
    root?.render(null)
    root = undefined

    const scrollY = document.body.style.top
    document.body.style.top = ''
    document.body.classList.remove('has-modal')
    const modalElement = document.getElementById('ModalWrapper')
    modalElement?.remove()
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
  }

  openModal({ component, options = {}, ...props }) {
    props.closeModal = () => this.closeModal(this)
    const ComponentWithProps = cloneElement(component, {
      ref: this.ref,
      ...props
    })

    if (!document.getElementById('ModalWrapper')) {
      appendModalWrapperToTheDocument()
    }
    if (!root) {
      root = createModalRoot()
    }

    root.render(
      <FocusTrap open>
        <div
          tabIndex={-1}
          className={`Modal ${
            options.wrapperClassName ? options.wrapperClassName : ''
          }`}>
          <div
            className={`ModalContent ${
              options.className ? options.className : ''
            }`}
            style={{ ...options.styles }}>
            {ComponentWithProps}
          </div>
        </div>
      </FocusTrap>
    )

    if (options.enableEscKey) {
      document.addEventListener('keyup', this.closeWithEscKey, false)
    }

    if (options.closeOnOutsideClick) {
      document.addEventListener('mousedown', this.handleClickOutside, true)
    }

    document.body.style.top = `-${window.scrollY}px`
    document.body.classList.add('has-modal')
  }
}
